module.exports = __webpack_public_path__ + "img/violenceDynamic.3238d8b9.svg";